import React, { useMemo } from 'react';

const FormLivePreview = ({
  form,
  items = [],
  renderPreviewInput = () => null,
}) => {
  const sortedItems = useMemo(
    () => [...(items || [])].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)),
    [items],
  );

  const placeholder = `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`;

  return (
    <div
      className="card"
      style={{ width: '650px', margin: 'auto', boxShadow: '0 0.25rem 1rem rgba(46,46,46,0.25)' }}
    >
      <div className="card-header bg-primary text-white d-flex align-items-start justify-content-between">
        <div>
          <div className="fs-5 text-white">{form?.name || 'Form Preview'}</div>
          <span className="text-sm">{form?.description}</span>
        </div>
      </div>
      <div className="card-body" style={{ maxHeight: 'calc(100vh - 233px)', overflowY: 'auto' }}>
        <div className="row g-3">
          {sortedItems.length === 0 && (
            <div className="text-center text-neutral-500 py-3 w-100">No items to preview.</div>
          )}
          {sortedItems.map((it) =>
            it.heading === 1 ? (
              <div key={it.id} className="col-12 py-8">
                <div className="fw-bold fs-6">{it.description}</div>
              </div>
            ) : (
              <div key={it.id} className={`col-md-${it.width || 12} mb-16`}>
                <div className="p-12 border radius-6 h-100 d-flex flex-column">
                  <div>
                    {it.description}
                    {Boolean(it.required) && <span className="text-danger ms-4">*</span>}
                  </div>
                  <div className="text-sm text-muted">{it.instructions}</div>
                  <div className="mt-8">{renderPreviewInput(it)}</div>
                  {it.images && it.images.length > 0 && (
                    <div className="mt-16 d-flex">
                      <div style={{ width: '50%', paddingRight: '6px' }}>
                        <img
                          src={it.images?.[0] ? `${process.env.REACT_APP_SPACES_BASE}/${it.images[0]}` : placeholder}
                          alt="form item"
                          style={{
                            width: '100%',
                            maxHeight: '200px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            display: 'block',
                          }}
                        />
                      </div>
                      {it.images?.[1] && (
                        <div style={{ width: '50%', paddingLeft: '6px' }}>
                          <img
                            src={it.images?.[1] ? `${process.env.REACT_APP_SPACES_BASE}/${it.images[1]}` : placeholder}
                            alt="form item"
                            style={{
                              width: '100%',
                              maxHeight: '200px',
                              objectFit: 'cover',
                              borderRadius: '6px',
                              display: 'block',
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default FormLivePreview;
